var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLevelBg = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 246,
  height: 280,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#F5F5F5",
  stroke: "#E8E8E8",
  strokeWidth: 10,
  d: "m235.831 69.515-2.499 4.33 2.499-4.33L127.164 6.822a9 9 0 0 0-8.995 0L9.503 69.515A9 9 0 0 0 5 77.31v125.38a9 9 0 0 0 4.502 7.795l108.667 62.693a9 9 0 0 0 8.995 0l108.667-62.693a9 9 0 0 0 4.502-7.795V77.31a9 9 0 0 0-4.502-7.795Z"
})));
export { SvgLevelBg as ReactComponent };
export default __webpack_public_path__ + "94fc6e52c4554dcd68350ec235fa7624.svg";